export default "__VITE_ASSET__954xUkY6__"